import { Link } from "react-router-dom";
import { MessageCircle, Phone, XCircle } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { usePublicConfig, waLink, telLink, formatPhone } from "@/lib/config";
import Reveal from "@/components/Reveal";

export default function Cancel() {
  const { t } = useLanguage();
  const cfg = usePublicConfig();
  return (
    <div data-testid="payment-cancel-page" className="flex min-h-screen items-center justify-center bg-surface pt-32">
      <div className="mx-auto max-w-md px-6 pb-24 text-center">
        <Reveal>
          <XCircle size={44} strokeWidth={1} className="mx-auto text-gold-dark" />
          <h1 className="mt-8 font-display text-4xl font-light tracking-tight text-navy">{t.pay.cancelled}</h1>
          <p className="mt-4 text-sm font-light leading-relaxed text-navy/55">{t.pay.cancelledSub}</p>
        </Reveal>
        <Reveal delay={1} className="mt-10 flex flex-col items-center gap-4">
          <Link to="/checkout" data-testid="cancel-retry-cta" className="btn-primary-luxe">{t.pay.retry}</Link>
          <Link to="/shop" data-testid="cancel-shop-cta" className="text-[11px] font-semibold uppercase tracking-[0.18em] text-navy/50 transition-colors hover:text-gold-dark">
            {t.cart.continue}
          </Link>
          {(cfg?.whatsapp || cfg?.phone) && (
            <div data-testid="cancel-support" className="mt-4 w-full border border-navy/10 bg-white px-5 py-4">
              <p className="text-[11px] font-light text-navy/60">{t.co?.supportMsg}</p>
              <div className="mt-2 flex items-center justify-center gap-5">
                {cfg?.whatsapp && (
                  <a href={waLink(cfg.whatsapp, t.co?.supportMsg)} target="_blank" rel="noopener noreferrer" data-testid="cancel-support-whatsapp" className="inline-flex items-center gap-1.5 text-[11px] font-semibold text-navy transition-colors hover:text-gold-dark">
                    <MessageCircle size={13} /> WhatsApp
                  </a>
                )}
                {cfg?.phone && (
                  <a href={telLink(cfg.phone)} data-testid="cancel-support-phone" className="inline-flex items-center gap-1.5 text-[11px] font-semibold text-navy transition-colors hover:text-gold-dark">
                    <Phone size={13} /> {formatPhone(cfg.phone)}
                  </a>
                )}
              </div>
            </div>
          )}
        </Reveal>
      </div>
    </div>
  );
}
